import { z } from 'zod';

import { api } from 'common';

import { AsynchronousJobFormFields } from './FormFields';
import { ASYNCHRONOUS_JOB_VARIANTS } from './Variants';
import { asynchronousJobsDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

import JobKind = api.RpaJob.Kind;

const baseSchema = z.object({
  timeout: z.object({
    value: z.number().positive().int(),
    units: z.enum(api.FlowDefinition.DurationUnits),
  }),
  v2: z.boolean().optional(),
});

const jobKindSchemas = Object.values(ASYNCHRONOUS_JOB_VARIANTS).map(({ schema: variantSchema }) =>
  baseSchema.extend(variantSchema.shape)
) as unknown as [z.ZodObject, ...z.ZodObject[]];

export const asynchronousJobNodeConfig: BlockConfigProps = {
  defaultConfig: {
    jobKind: JobKind.ExportDummyValues,
    timeout: {
      value: 1,
      units: api.FlowDefinition.DurationUnits.Hours,
    },
    payload: {
      foo: '',
    },
  },
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'notableClassicJob',
  configFields: {
    schema: z.discriminatedUnion('jobKind', jobKindSchemas),
    FormFields: AsynchronousJobFormFields,
  },
  documentationMarkdown: asynchronousJobsDocumentationMarkdown,
};
